import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import AGGridColumnTemplate from "@/utils/UIConstants/AGGridColumns/AGGridColumnTemplate.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import CommonConstants from "@/utils/constants/CommonConstants.ts";
import Translator from "@/utils/common/Translator.ts";

export default class AGGridLinkColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer();
    return colDef;
  }

  private cellRenderer(): any {
    return (params: ICellRendererParams) => {
      let link = params.value;
      if (!link)
        return '';
      const normalizedLink = PlaceUtils.normalizedGUILink(link)
      if (ObjectChecker.isEmptyOrNull(link))
        return "";
      let title = link;
      const separator = CommonConstants.URL_TITLE_SEPARATOR;
      if (link.includes(separator)) {
        title = link.substring(0, link.indexOf(separator))
        const res = "res:";
        if (title.startsWith(res))
          title = Translator.translateId(title.substring(res.length))
      }
      return AGGridColumnTemplate.linkInBlank(normalizedLink ?? '', title);
    }
  }
}
